var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.itemCourses,"item-text":"name","item-value":"id","menu-props":"auto","placeholder":"Wszystkie kierunki","single-line":"","multiple":"","chips":"","deletable-chips":""},model:{value:(_vm.courseSelected),callback:function ($$v) {_vm.courseSelected=$$v},expression:"courseSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }